import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import {
  VehicleFaultEventDto,
  useGetFaultEventsPaginatedWithSearchQuery,
} from "../../../api/vehiclesApi";
import FaultsTable from "./FaultsTable";
import { createSearchParams, hasActiveFilters } from "../../../utils/searchApiUtils";
import { useInfiniteDataTableItems } from "../../../hooks/useInfiniteDataTableItems";
import { DEFAULT_DATA_TABLE_PAGE_SIZE } from "../../../constants/dataTable";

const VehicleFaultsTab: React.FC = () => {
  const [page, setPage] = useState(0);
  const [searchFilters, setSearchFilters] = useState<Record<string, any>>({});

  const { data, isLoading, isFetching, error } = useGetFaultEventsPaginatedWithSearchQuery(
    createSearchParams(
      { pageNumber: page + 1, pageSize: DEFAULT_DATA_TABLE_PAGE_SIZE },
      hasActiveFilters(searchFilters) ? searchFilters : undefined
    )
  );
  const { accumulatedItems: faults, resetAccumulatedItems } =
    useInfiniteDataTableItems<VehicleFaultEventDto>(data?.items, page);

  const handleSearchChange = (filters: Record<string, any>) => {
    setSearchFilters(filters);
    resetAccumulatedItems();
    setPage(0);
  };

  const handleLoadMore = () => {
    if (data?.hasNextPage && !isFetching) {
      setPage((currentPage) => currentPage + 1);
    }
  };

  if (error) {
    return (
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography color="error">Error loading vehicle faults</Typography>
      </Box>
    );
  }

  return (
    <FaultsTable
      faults={faults}
      isLoading={isLoading && faults.length === 0}
      totalCount={data?.totalCount}
      hasNextPage={data?.hasNextPage}
      isLoadingMore={isFetching && faults.length > 0}
      onLoadMore={handleLoadMore}
      
      // Search functionality
      enableSearch={true}
      onSearchChange={handleSearchChange}
    />
  );
};

export default VehicleFaultsTab;
